import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  totalPages: 0,
  page: 1,
  count: 0,
  allCampaignLoading: false,
  allCampaignList: [],
};

const allCampaignSlice = createSlice({
  name: "allCampaign",
  initialState,
  reducers: {
    setAllCampaignList(state, action) {
      state.allCampaignList = action?.payload?.pagination
        ? [...state.allCampaignList, ...action.payload?.allCampaignList]
        : action.payload?.allCampaignList;
      state.allCampaignLoading = action.payload?.allCampaignLoading ?? false;
      state.count = action.payload?.count ?? 0;
      state.totalPages = action.payload?.totalPages ?? 0;
      state.page = action.payload?.page ?? 0;
    },

    setAllCampaignLoading(state, actions) {
      state.allCampaignLoading = actions.payload;
    },
  },
});

export const allCampaignActions = allCampaignSlice.actions;

export default allCampaignSlice;
